<template>
  <footer class="mock-footer">
    <div class="mock-footer-inner home-shell">
      <div class="mock-footer-brand">
        <a :href="localizedPath('/')" :aria-label="labels.homeLabel">
          <img src="/images/logo/logo.svg" alt="Sharewell" width="148" height="55">
        </a>
        <p>{{ labels.footerCopy }}</p>
      </div>
      <nav class="mock-footer-links" :aria-label="labels.footerNavigationLabel">
        <section class="mock-footer-group">
          <h2>{{ labels.productGroup }}</h2>
          <div>
            <a :href="localizedPath('/occasions')">{{ labels.occasions }}</a>
            <a :href="localizedPath('/#how-it-works')">{{ labels.how }}</a>
            <a :href="localizedPath('/#examples')">{{ labels.examples }}</a>
            <a :href="localizedPath('/pricing')">{{ labels.pricing }}</a>
          </div>
        </section>
        <section class="mock-footer-group">
          <h2>{{ labels.resourcesGroup }}</h2>
          <div>
            <a v-if="activeLocale === 'fr'" href="/blog/">{{ labels.blog }}</a>
            <a :href="researchPath">{{ labels.research }}</a>
          </div>
        </section>
        <section class="mock-footer-group">
          <h2>{{ labels.supportGroup }}</h2>
          <div>
            <a :href="localizedPath('/faq')">{{ labels.help }}</a>
            <a :href="localizedPath('/privacy')">{{ labels.privacy }}</a>
            <a :href="localizedPath('/terms')">{{ labels.terms }}</a>
          </div>
        </section>
      </nav>
      <div class="mock-social" :aria-label="labels.socialLabel">
        <a href="https://www.instagram.com/sharewell.io/" :aria-label="labels.instagramLabel">
          <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
            <rect x="5" y="5" width="14" height="14" rx="4" />
            <circle cx="12" cy="12" r="3" />
            <path d="M16.5 7.5h.01" />
          </svg>
        </a>
        <LanguageSelector
          id="languageSelect"
          class="language-select"
          :aria-label="labels.languageLabel"
        />
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { MARKETING_COPY } from '../../scripts/lib/marketing_chrome.mjs'
import LanguageSelector from './language_selector.vue'

export default {
  name: 'SharewellFooter',
  components: { LanguageSelector },
  setup() {
    const { locale } = useI18n()
    const activeLocale = computed(() => (MARKETING_COPY[locale.value] ? locale.value : 'en'))
    const labels = computed(() => MARKETING_COPY[activeLocale.value])

    const localizedPath = (path) => {
      if (activeLocale.value === 'fr') {
        if (path === '/') return '/fr'
        if (path.startsWith('/#')) return `/fr${path.slice(1)}`
        return `/fr${path}`
      }
      if (activeLocale.value === 'es') {
        if (path === '/') return '/es'
        if (path.startsWith('/#')) return `/es${path.slice(1)}`
        return `/es${path}`
      }
      return path
    }

    const researchPath = computed(() => (
      activeLocale.value === 'fr'
        ? '/fr/research/group-card-index-2026'
        : '/research/group-card-index-2026'
    ))

    return {
      activeLocale,
      labels,
      localizedPath,
      researchPath
    }
  }
}
</script>
